import {
    FETCH_WITHDRAM,
    FETCH_WITHDRAMS,
} from '../actions/withdram';


export const initialState = {
    isFetching: true,
    data: null
};

export const withdraws = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_WITHDRAMS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_WITHDRAMS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const withdraw = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_WITHDRAM}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_WITHDRAM}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/withdraw.js